// src/data/menu.js
const menu = [
  {
    label: "Dashboard",
    path: "/dashboard",
    icon: "🪙",
    roles: ["admin"],
    subMenu: [],
    page: "Dashboard",
  },
  {
    label: "Flash News",
    path: "/dashboard/flash-news",
    icon: "📜",
    roles: ["admin"],
    subMenu: [],
    page: "FlashNewsForm",
  },
    {
    label: "Scrolling Message",
    path: "/dashboard/scrolling-message",
    icon: "📜",
    roles: ["admin"],
    subMenu: [],
    page: "ScrollingMessage",
  },
  {
    label: "Uploads",
    icon: "💰",
    roles: ["admin"],
    subMenu: [
      {
        label: "Home Page Data",
        path: "/dashboard/home-page-data",
        roles: ["admin"],
        page: "HomePageData",
      },
      {
        label: "Aboutus Data",
        path: "/dashboard/about-data",
        roles: ["admin"],
        page: "About",
      },
       {
        label: "Contact Us Data",
        path: "/dashboard/contact-data",
        roles: ["admin"],
        page: "Contact",
      },
       {
        label: "Upload Gallary",
        path: "/dashboard/upload-gallary",
        roles: ["admin"],
        page: "UploadPhoto",
      },
      //  {
      //   label: "Upload PDF (LKG-5th Class)",
      //   path: "/dashboard/upload-pdf",
      //   roles: ["admin"],
      //   page: "UploadPDF",
      // },
      //  {
      //   label: "Upload Links(6th-10th Class)",
      //   path: "/dashboard/upload-links",
      //   roles: ["admin"],
      //   page: "UploadLinks",
      // },
       {
        label: "Upload News",
        path: "/dashboard/upload-news",
        roles: ["admin"],
        page: "UploadNews",
      },
       {
        label: "Upload Slide",
        path: "/dashboard/upload-slide",
        roles: ["admin"],
        page: "UploadSlide",
      },
       {
        label: "Upload Header Image",
        path: "/dashboard/upload-header-image",
        roles: ["admin"],
        page: "UploadHeaderImage",
      }
,
       {
        label: "Upload Exam Paper",
        path: "/dashboard/exam-papers",
        roles: ["admin"],
        page: "UploadPaper",
      }
      ,
       {
        label: "Upload Exam Key",
        path: "/dashboard/exam-keys",
        roles: ["admin"],
        page: "UploadKey",
      }
      ,
       {
        label: "Upload Exam Solution",
        path: "/dashboard/exam-solutions",
        roles: ["admin"],
        page: "UploadSolution",
      }
      ,
       {
        label: "Upload Video Links",
        path: "/dashboard/video-links",
        roles: ["admin"],
        page: "VideoLinkManager",
      }
     
    ],
  
  }

 ];

export default menu;
